"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var updateFavoritesUserOption_1 = require("./../updateFavoritesUserOption");
var datapoints_1 = require("../../datapoints");
var owa_analytics_1 = require("owa-analytics");
var store_1 = require("../../store/store");
var owa_mail_persona_search_folder_services_1 = require("owa-mail-persona-search-folder-services");
var owa_trace_1 = require("owa-trace");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_mail_folder_forest_store_1 = require("owa-mail-folder-forest-store");
/**
 * Add or remove the given personaId from the favorite list
 * @param idToUpdate the id to remove
 * @param state the state which contains the favoritesPersonaNodes and the persona id to update
 */
var removeFavoritePersonaAction = legacy_1.action('removeFavoritePersona', datapoints_1.default.RemoveFavoritePersonaAction)(function removeFavoritePersona(personaId, actionSource, isRetry) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var favoritesStore, persona, searchFolderId, indexOfElementToRemove, selectedPersonaNode, error_1, _a, eventName, customData, error_2, _b, eventName, customData;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    favoritesStore = store_1.getStore();
                    favoritesStore.isFavoritePersonasChangeable = false;
                    persona = favoritesStore.favoritesPersonaNodes.get(personaId);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 9, , 10]);
                    if (!persona) {
                        throw new Error('Cannot find the persona id in favorites list.');
                    }
                    searchFolderId = persona.searchFolderId;
                    indexOfElementToRemove = favoritesStore.orderedFavoritesNodeIds.indexOf(personaId);
                    if (indexOfElementToRemove > -1) {
                        favoritesStore.orderedFavoritesNodeIds.splice(indexOfElementToRemove, 1);
                    }
                    favoritesStore.favoritesPersonaNodes.delete(personaId);
                    return [4 /*yield*/, updateFavoritesUserOption_1.default()];
                case 2:
                    _c.sent();
                    selectedPersonaNode = owa_mail_folder_forest_store_1.getSelectedNode();
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 7, , 8]);
                    if (!(selectedPersonaNode.id === personaId)) return [3 /*break*/, 4];
                    selectedPersonaNode.markedForDeletion = true;
                    return [3 /*break*/, 6];
                case 4: 
                // If the action comes from LPC or the left nav we delete the folder immediately
                return [4 /*yield*/, owa_mail_persona_search_folder_services_1.deleteFolders([searchFolderId], true /* permanentlyDelete */)];
                case 5:
                    // If the action comes from LPC or the left nav we delete the folder immediately
                    _c.sent();
                    _c.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    error_1 = _c.sent();
                    _a = datapoints_1.default.DeleteFolderFailure.datapoint, eventName = _a.name, customData = _a.customData;
                    owa_trace_1.trace.warn(eventName + ': ' + error_1);
                    owa_analytics_1.logUsage(eventName, customData(error_1.toString()));
                    return [3 /*break*/, 8];
                case 8:
                    favoritesStore.isFavoritePersonasChangeable = true;
                    return [3 /*break*/, 10];
                case 9:
                    error_2 = _c.sent();
                    favoritesStore.isFavoritePersonasChangeable = true;
                    _b = datapoints_1.default.RemoveFavoritePersonaFailure.datapoint, eventName = _b.name, customData = _b.customData;
                    if (isRetry) {
                        // This will log error as well
                        owa_trace_1.trace.error({ message: eventName, error: error_2 });
                    }
                    else {
                        owa_trace_1.trace.warn(eventName + ': ' + error_2);
                    }
                    owa_analytics_1.logUsage(eventName, customData(error_2.toString(), isRetry));
                    // Add back to store if needed
                    if (persona && !favoritesStore.favoritesPersonaNodes.has(persona.id)) {
                        favoritesStore.orderedFavoritesNodeIds.push(persona.id);
                        favoritesStore.favoritesPersonaNodes.set(persona.id, persona);
                    }
                    throw tslib_1.__assign({ type: 'RemoveFavoritePersonaError' }, error_2);
                case 10: return [2 /*return*/];
            }
        });
    });
});
exports.default = removeFavoritePersonaAction;
//# sourceMappingURL=removeFavoritePersona.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/people/removeFavoritePersona.js
// module id = 3657
// module chunks = 14